import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import RaddissonSelection from "../Selection2/radissonSelection";
import RadissonShow from "./commercialimagesshow/RadissonShow";
import UnodcSelection from "../Selection2/unodcSelection";
import MariottSelection from "../Selection2/MariottSelection";
import MinimalistSelection from "../Selection2/MinimalistSelection";
import MinimalistShow from "./commercialimagesshow/MinimalistShow";

export default function MinimalistComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis6.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">A Minimalist Office Concept</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>role in project: 3D drawings</span>
                <span>project duration: 1 week</span>
                <span>year of completion: 2022</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
                           src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis2.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                              src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis8.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                MINIMALIST,
                <br />
                FUNCTIONAL,
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                TRANSPARENT,
                <br />
                Harmonious,{" "}
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Sophisticated,
                <br />
                Balanced
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              "This conceptual office design balances minimalism and modern
              functionality, where transparency, open space, and organic
              elements come together to create a harmonious, focused, and
              sophisticated work environment."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                           src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis8.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              This conceptual office design captures a blend of minimalism and
              modern functionality, with a focus on transparency and open
              spatial dynamics.
              <br />
              <br />
              The glass desk and shelving system introduce a sense of lightness
              and clarity, while the strategic arrangement of objects ensures
              balance and focus. The inclusion of organic elements, like the
              bonsai tree, creates harmony with the sleek industrial tones of
              the space.
              <br />
              <br />
              The geometric wall panel and metallic accents add a refined
              sophistication, enhancing the overall aesthetic without
              overwhelming the workspace's purpose-driven ambiance.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                              src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis1.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <MinimalistSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
                          src="../../Images/CommercialImages/14-AMinimalistOfficeConcept/Ofis4.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                "an office concept designed for clarity and modern
                sophistication."
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <MinimalistShow/>
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
